import { useMutation, useQuery, UseQueryResult } from '@tanstack/react-query';
import { queryKeysClient } from 'common/clients/query-key.client';
import { EQueryKeys } from 'common/enums/query-kyes.enum';
import {
  createPermissionService,
  deletePermissionService,
  updatePermissionService
} from '../services/permissions.service';
import {
  TCreatePermissionReqData,
  TGetPermissionsListParams,
  TGetPermissionsListResData,
  TUpdatePermissionReqData,
} from '../types/permissions.types';

export const useGetPermissionsListQuery = (
  params: TGetPermissionsListParams,
  options?: any
): UseQueryResult<TGetPermissionsListResData> =>
  useQuery({
    ...queryKeysClient[EQueryKeys.PermissionQueryKeys].getPermissionsList(params),
    ...options
  });

export const useCreatePermissionMutation = (): any =>
  useMutation({
    mutationFn: (data: { requestData: TCreatePermissionReqData }) => createPermissionService(data.requestData),
  });

export const useUpdatePermissionMutation = (): any =>
  useMutation({
    mutationFn: (data: { permissionGUID: string, requestData: TUpdatePermissionReqData }) =>
      updatePermissionService(data.permissionGUID, data.requestData),
  });

export const useDeletePermissionMutation = (): any =>
  useMutation({
    mutationFn: (data: { permissionGUID: string }) => deletePermissionService(data.permissionGUID),
  });
